import { Button } from "@chakra-ui/react";
import { getApiUrl } from "utils/ez4castConfig";
import {
    Box, Flex, Center, Heading, Text,

} from "@chakra-ui/react";
import {
    Link,
    useMediaQuery,
    Image,
} from "@chakra-ui/react"


import { createSlug, extractTweets } from "controllers/seo";

import React, { useEffect } from "react";

import { useSession } from "next-auth/client";
import { useRouter } from "next/dist/client/router";

import { firebaseClient } from "firebaseClient";
import Thread from "components/tweets/masonry/thread";
import safeJsonStringify from 'safe-json-stringify';
import { formatDistance } from "date-fns";
import { LinkShare } from "components/tweets-public/linkShare";
import { CustomHead } from "components/custom-head";
import { ArrowForwardIcon, ArrowBackIcon } from '@chakra-ui/icons'
import twitter from "twitter-text";
import async from 'async';
import { useWindowWidth } from '@react-hook/window-size';

export default function PublicTweet({ query, tweet, thread }) {
    const [isTooSmall] = useMediaQuery("(max-width: 800px)");
    const screenWidth = useWindowWidth();

    useEffect(() => {

    }, [isTooSmall, screenWidth]);


    // console.log({ tweet });

    let url = "https://tweethunter.io/thread-finder/" + tweet?.twUserName + "/" + (tweet?.slug ?? tweet?.id);
    let image = "https://ondemand.bannerbear.com/simpleurl/NXyx5P8mAAp8MeZV14/image";
    image += "/handle/text/" + encodeURIComponent("@" + tweet?.twUserName);
    image += "/name/text/" + encodeURIComponent(tweet?.name);
    image += "/profile/image_url/" + encodeURIComponent(tweet?.profilePic);

    let title = "";
    if (tweet?.blogTitle) title = tweet?.blogTitle
    else {
        title = tweet?.text?.split("\n")?.[0] ?? "Check out this thread" + tweet?.name ? ` from ${tweet.name}` : "";
    }
    image += "/title/text/" + encodeURIComponent(title);
    let desc = title;

    if (title?.length > 60)
        title = title.substring(0, 80) + "...";

    if (desc?.length > 150)
        desc = desc.substring(0, 150) + "...";

    if (tweet?.name) {
        title += " | by " + tweet?.name;
        desc += " | by " + tweet?.name;
    }




    console.log("isTooSmall: " + isTooSmall);
    console.log("screenWidth: " + screenWidth);

    return (
        <Box maxW="600px" p={10} margin="auto">

            <CustomHead
                title={title}
                desc={desc}
                url={url}
                image={image}
            />

            {
                tweet !== undefined && thread ? (
                    <Flex flexDir="column" >

                        <Heading my={5} as="h1" fontSize={tweet.blogTitle ? "2xl" : "xl"}>{tweet.blogTitle ?? title}</Heading>

                        <Flex mt={5} flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }}>
                            <Flex justifyContent="flex-start">
                                <Image
                                    width={10}
                                    height={10}
                                    borderRadius={20}
                                    ml={0}
                                    //@ts-ignore
                                    src={tweet.profilePic}
                                    fallbackSrc="/assets/resources/emptyProfile.png"
                                />
                                <Flex flexDir="column" ml={3}>
                                    <Text fontWeight="700" maxW="180px" noOfLines={1} wordBreak="break-all">
                                        {tweet.name}
                                    </Text>
                                    <Text fontWeight="400" color="gray.400" maxW="180px" noOfLines={1} wordBreak="break-all">
                                        {/* <Link target="_blank" href={"https://twitter.com/" + tweet.twUserName} >@{tweet.twUserName}</Link> */}
                                        <Link href={"/thread-finder/" + tweet.twUserName} >@{tweet.twUserName}</Link>
                                    </Text>
                                </Flex>
                            </Flex>
                            <Box mt={{ base: 4, md: 0 }} >
                                <LinkShare url={url} title={title} position={isTooSmall ? "flex-start" : "flex-end"} />
                            </Box>
                        </Flex>


                        <Flex mt={4} mb={5} color="gray.400">
                            <Text>{formatDistance(new Date(tweet.dateSent), new Date(), { addSuffix: true })}</Text>
                            {
                                !!tweet.id_str && (
                                    <Text ml={2}>•<Link ml={2} isExternal href={"https://twitter.com/" + tweet.twUserName + "/status/" + tweet.id_str} >View on X</Link></Text>
                                )
                            }
                        </Flex>

                        <Thread
                            threadTweets={thread}
                            disableNbChar={true}
                            image={tweet.profilePic}
                            name={tweet.name}
                            mode="blog"
                            disablePreview={tweet?.isPreventLinkExpand}
                            maxW="800px"
                            isDisablePicture={true}
                            preFetchedTweets={tweet.preFetchedTweets}
                        />

                        <Flex flexDir="column">
                            {
                                !!tweet.id_str && (
                                    <Flex w="100%" justifyContent="space-between">
                                        <Link textDecoration="underline" href={"/thread-finder/" + tweet.twUserName} mt={5} color="gray.500"><ArrowBackIcon /> More from @{tweet.twUserName}</Link>
                                        <Link minW="140px" textDecoration="underline" isExternal href={"https://twitter.com/" + tweet.twUserName + "/status/" + tweet.id_str} mt={5} color="gray.500">Reply on X <ArrowForwardIcon /></Link>
                                    </Flex>
                                )
                            }
                            <Center mt={20} flexDirection="column">
                                <Text fontWeight={600} fontSize="sm">
                                    Page created with TweetHunter
                                </Text>
                                <Button m={5} size="sm" variant={"primary"} as="a" target="_blank" href="https://tweethunter.io/">
                                    Write your own
                                </Button>
                            </Center>
                        </Flex>
                    </Flex>
                ) : (
                    <Center mt={20} flexDirection="column">
                        <Text fontWeight={600}>
                            Tweet not found
                        </Text>
                        <Button m={5} variant={"primary"} as="a" target="_blank" href="https://tweethunter.io/">
                            Write your own
                        </Button>
                    </Center>
                )
            }
        </Box>
    );
};

export async function getServerSideProps({ params, res }) {

    console.log(params);

    let props = { ...params }

    let tweet: any = undefined;
    let thread: any = undefined;

    let refTweets = [];

    if (params?.id && params?.id?.length > 20) { // uuid
        const db = firebaseClient.firestore();

        // try get from TH users from slug
        let docs = await db.collectionGroup('tweets').where('slug', '==', params.id).get();
        console.log("nb docs from slug: " + docs.docs?.length);
        if (docs.size > 0) {
            tweet = docs.docs[0].data();
        }

        // try get from zIndex in case the tweet is NOT from a TH users and the slug has been already saved
        if (!tweet) {
            let docs = await db.collection('zIndex').where('url', '==', "https://tweethunter.io/thread-finder/" + params.twUserName + "/" + params.id).get();
            console.log("nb docs from zIndex: " + docs.docs?.length);
            if (docs.size > 0) {
                let zIndex = docs.docs[0].data();
                params.id = zIndex?.id;
            }
        }

        // try get from TH users from id
        if (!tweet) {
            console.log("tweet not found from slug")
            docs = await db.collectionGroup('tweets').where('id', '==', params.id).get();
            console.log("nb docs from id: " + docs.docs?.length + " - " + params.id);
            if (docs.size > 0)
                tweet = docs.docs[0].data();
        }

        if (tweet) {
            // tweet.created_at = tw.created_at?.toDate ? tw.created_at.toDate().toString() : tw.created_at;
            tweet.dateCreated = tweet.dateCreated?.toDate ? tweet.dateCreated.toDate() : tweet.dateCreated;
            tweet.dateSent = tweet.dateSent?.toDate ? tweet.dateSent.toDate() : tweet.dateCreated;
            // console.log(tweet.dateCreated);

            if (tweet.id_str)
                tweet.text = tweet.text.replace(/\[tweet\]/g, "https://twitter.com/" + tweet.twUserName + "/status/" + tweet.id_str);

            let tweets = tweet.text.split("\n\n\n");

            thread = tweets;

            if (tweet) {
                tweet.preFetchedTweets = await extractTweets(tweet.text);
                props.tweet = tweet;
                props.thread = thread;
            }
        }
    }

    // try get from NON-TH users from id
    if (!tweet && params?.id && params?.id !== "requestProvider.js.map") {
        console.log("tweet not found on TH DB - looking for it on ez4cast: " + params?.id);
        props = await pullFromApi(params?.id);

    }

    if (props?.tweet?.id_str)
        res.setHeader('Cache-Control', 'public, max-age=2592000'); // 30 days

    if (!props) {
        return { props: {} };
    }

    if (props.tweet && !props.tweet?.slug)
        await createSlug(props.tweet);

    // console.log(props.tweet);

    // if (props?.tweet?.slug && props?.tweet?.text?.length > 300)
    //     index(params?.id, "https://tweethunter.io/thread-finder/" + props.tweet?.twUserName + "/" + (props.tweet?.slug), "post", {idTweet: props?.tweet?.id ?? props?.tweet?.id_str, twUserName: props.tweet?.twUserName}); 

    console.log("slug: " + props.tweet?.slug);

    const stringifiedData = safeJsonStringify(props);
    props = JSON.parse(stringifiedData);

    return {
        props: props
    };
}

async function pullFromApi(id) {

    console.log("pullFromApi for id: " + id);
    let props = { id, account: {} } as any;

    let result = await fetch(`${getApiUrl("getUniqueTweet")}?id=${id}`);
    let json = await result.json();
    console.log(json);

    if (json?.success && json?.tweet && json?.account) {
        props.account = {
            twUserName: json?.account.screen_name,
            name: json?.account.name,
            image: json?.account?.profile_image_url_https?.replace("normal", "400x400"),
            description: twitter.autoLink(json?.account.description, {
                urlEntities: json?.account?.entities?.description?.urls,
                usernameIncludeSymbol: true,
                targetBlank: true,
            }) ?? json?.account.description,
            followers_count: json?.account.followers_count,
        }

        // console.log(json.tweet);

        props.tweet = json.tweet;
        props.tweet.text = props.tweet.full_text;
        props.tweet.twUserName = props.account?.twUserName;
        props.tweet.name = props.account?.name;
        props.tweet.profilePic = props.account?.image;
        props.tweet.dateSent = new Date(props.tweet.created_at);

        // props.thread = props.tweet.thread?.map((tweet) => tweet.text);
        props.thread = [];
        props.tweet.preFetchedTweets = [];

        if (!props?.tweet?.thread)
            props.tweet.thread = [];

        // props.tweet.thread.forEach(tw => {
        // for await (let tw of props?.tweet?.thread) {
        await async.mapLimit(props?.tweet?.thread, 5, async (tw) => {
            let tempTweets = await extractTweets(props.tweet.text);
            props.tweet.preFetchedTweets = props.tweet.preFetchedTweets.concat(tempTweets);
            // props.thread.push(text);
            props.thread.push(tw);
        });
    }

    return props;
}
